import { firebaseAnalyticsAdapter } from '@/adapters/analytics';
import { createUserAwareAnalyticsAdapter } from '@/adapters/analytics/createUserAwareAnalyticsAdapter';
import { getCurrentAccountId } from '@/adapters/analytics/currentAccountId';
import { getCurrentUserId } from '@/adapters/analytics/currentUserId';
import {
  createMeetingAnalyticsStore,
  type MeetingAnalyticsAdapters,
} from '@/stores/createMeetingAnalyticsStore';

const productionAdapters: MeetingAnalyticsAdapters = {
  analytics: createUserAwareAnalyticsAdapter(
    firebaseAnalyticsAdapter,
    () => getCurrentUserId(),
    () => getCurrentAccountId(),
  ),
};

const useMeetingAnalyticsStore = createMeetingAnalyticsStore(productionAdapters);

export { useMeetingAnalyticsStore };
